<script>
	import { onMount } from "svelte";
	import PageSection from "../../components/PageSection.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";
	import { registerSubmit } from "../../tealium";

	export let pageIndex = null;
	export let pageTitle = null;

	pageNumber.update((p) => pageIndex);
	document.title = pageTitle;

	window.onbeforeunload = null;

	onMount(() => {
		registerSubmit($model.Contact.EmailAddress, $model.Contact.PhoneNumber, $model.RegistrationNumber);
	});
</script>

<PageSection>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<h1>Thank you</h1>
			{#if $model.RegistrationStatus === "Active - Ineligible"}
				<p>
					Based on the information that you have provided you are not eligible to register for the class
					action. If you wish to contact Shine Lawyers with further information please call
					<ClassActionPhoneNumber></ClassActionPhoneNumber> or email <ClassActionEmailAddress
					></ClassActionEmailAddress> and quote your registration number
					<strong>{$model.RegistrationNumber}</strong>.
				</p>
			{:else}
				<p>
					Thank you for completing your registration for the {projectSettings.classActionName}.
				</p>

				<p>
					Your registration number is: <strong>{$model.RegistrationNumber}</strong>
				</p>

				<p>
					If you confirmed that you are willing to provide a confidential statement about your experience a
					member of our team will be in touch to arrange a time to speak.
				</p>

				<p>
					If you have any questions, please contact Shine Lawyers on
					<ClassActionPhoneNumber></ClassActionPhoneNumber>, or at <ClassActionEmailAddress
					></ClassActionEmailAddress> and quote the registration number above.
				</p>
			{/if}
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}
</style>
